import styled from 'styled-components'
import { Text1 } from '../../../ui/text'
import {
	FixedBottomButtonContainer,
	ScreenContainer as BaseScreenContainer,
	BackButton as BaseBackButton
} from '../styled'

export const Content = styled(BaseScreenContainer).attrs({
	$justifyContent: 'flex-start'
})`
	display: flex;
	flex-direction: column;
	gap: 20px;
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		padding: 40px 20px;
	}
`


export const ExperienceContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
`



export const List = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 0;
	GAP: 16px;
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		gap: 32px;
	}
`

export const ListItem = styled.div`
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 56px;
	height: 56px;
	border-radius: 16px;
	background-color: ${({ $item, $ratingNumber, theme }) =>
		$ratingNumber === $item ? theme.colors.brand.blueOmint : theme.colors.greys.hoverBg};
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		width: 48px;
		height: 48px;
		border-radius: 12px;
	}
`

export const RatingBadge = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	border-radius: 50%;
	border: 2px solid
		${({ $item, $ratingNumber, theme }) =>
			$ratingNumber !== $item ? theme.colors.text.primaryText : theme.colors.brand.white};
	background-color: ${({ $item, $ratingNumber, theme }) =>
		$ratingNumber === $item ? theme.colors.brand.blueOmint : theme.colors.greys.hoverBg};
	font-weight: 600;
	color: ${({ $item, $ratingNumber, theme }) =>
		$ratingNumber !== $item ? theme.colors.text.primaryText : theme.colors.brand.white};
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		width: 28px;
		height: 28px;
		font-size: 14px;
	}
`

export const RateTextContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`

export const Comments = styled.textarea`
	padding: 8px;
	resize: none;
	border-radius: 4px;
	border: 1px solid ${props => props.theme.colors.greys.disabledGrey};
	background: ${({ theme }) => theme.colors.brand.white};
	outline-color: ${({ theme }) => theme.colors.brand.blueOmint};
	font-size: 14px;
	min-height: 40px;
	::placeholder {
		color: ${props => props.theme.colors.text.secondaryText};
	}
`

export const ButtonContainer = styled(FixedBottomButtonContainer)`
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		display: flex;
		justify-content: center;
		> button {
			max-width: 100%;
		}
	}
`

export const BackButton = styled(BaseBackButton).attrs({
	$gap: '8px'
})``
